import { StyleProp, ViewStyle } from "react-native";
import Styles from "./gutter.module.css";
export const listGutterStyle: StyleProp<ViewStyle> = [
  {
    scrollbarGutter: "stable",
  },
  {
    $$css: true,
    _: Styles.CustomScrollbar,
  } as any,
] as unknown as StyleProp<ViewStyle>;
